/**
 * Navigation Bar component
 * Main app navigation with user controls
 * Context: Global navigation for LostMind AI Video Lab
 */

import { 
  AppShell, 
  Group, 
  Button, 
  Text,
  UnstyledButton,
  Burger
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconVideo } from '@tabler/icons-react';
import { useNavigate, useLocation } from 'react-router-dom';

import { LoginButton } from '../auth/LoginButton';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [opened, { toggle }] = useDisclosure(false);

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <AppShell.Header px="md" style={{ height: 70 }}>
      <Group justify="space-between" h="100%">
        {/* Logo and brand */}
        <Group>
          <UnstyledButton onClick={() => handleNavigate('/')}>
            <Group gap="xs">
              <IconVideo size={28} color="var(--mantine-color-blue-6)" />
              <Text 
                size="lg" 
                fw={700}
                variant="gradient" 
                gradient={{ from: 'neural-blue', to: 'electric-cyan' }}
              >
                LostMind AI Video Lab
              </Text>
            </Group>
          </UnstyledButton>
        </Group>

        {/* Desktop navigation */}
        <Group gap="md" visibleFrom="sm">
          <Button 
            variant={location.pathname === '/' ? 'filled' : 'subtle'}
            onClick={() => handleNavigate('/')}
          >
            Home
          </Button>
          <Button 
            variant={location.pathname === '/dashboard' ? 'filled' : 'subtle'}
            onClick={() => handleNavigate('/dashboard')}
          >
            Dashboard
          </Button>
          <Button 
            variant={location.pathname.startsWith('/lab') ? 'filled' : 'subtle'}
            onClick={() => handleNavigate('/lab')}
          >
            Video Lab
          </Button>
        </Group>

        {/* User controls */}
        <Group gap="md">
          <LoginButton />

          {/* Mobile burger menu */}
          <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
        </Group>
      </Group>
    </AppShell.Header>
  );
}